// import { logger } from '@/helpers';
import { defineComponent,ref,computed ,watch ,onMounted} from 'vue'

import { useRouter } from "vue-router";
import { useStore } from "vuex";
import {  ApiService } from '@/api/api';

export default defineComponent({
  // type inference enabled
  name:'WelcomeBox',
  components:{
  },
  
  
  setup() {
    const router = useRouter();
    const store = useStore();

    const  checked = ref(false);
    const IsError = ref(false)
    const LoginService = computed(() => store.getters['AppConfig/getLoginService'])


    const IsShowConsent =ref(true)


    watch(checked, () => {
      IsError.value =false;
    })


    const ShowPopupCookie = () =>{
      store.dispatch('SetPopupCookie',true)

    }

    const StartTarot = async () =>{

      console.log(checked.value)

      if(checked.value == true){

        //
        if( localStorage.getItem('allow_cookie') != 'true'){
          const RequestParam = {
            "activity": "consent",
           
          }
      
          await ApiService.SaveUserActivity(RequestParam)

        }
        

        //
        localStorage.setItem('allow_cookie','true');

        router.push('/play')
      }else{
        IsError.value = true;
        localStorage.setItem('allow_cookie','false');
      }
      

    }


    onMounted(() => {
      if(localStorage.getItem('allow_cookie') ==  'true'){
        checked.value=true
        IsShowConsent.value = false
       
      }
    })

     

    return {checked,LoginService,IsError,IsShowConsent,ShowPopupCookie,StartTarot}
  

  
    

  

  //   // const year = ref< number>(2022)

  //   // year.value = 123
    
    
  
  }
})
